/* eslint-disable */

import Vue from 'vue'

import Cookies from 'js-cookie'
import { preventReClick, Int } from '@/utils/directive'// 防多次点击，重复提交 | 整数
// import Int from '@/utils/int' // 防多次点击，重复提交

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import i18n from './i18n/index.js'

import * as filters from './filters' // global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// import 'vue-googlemaps/dist/vue-googlemaps.css'
// import * as VueGoogleMaps from 'vue-googlemaps'
import * as VueGoogleMaps from 'vue2-google-maps'

import filter from '@/directive/thousandFilter.js' // 数字转换为千分位--指令
/* 注册过滤器 */
for (const key in filter) {
  if (filter.hasOwnProperty(key)) {
    const element = filter[key]
    Vue.filter(key, element)
  }
}


import format from 'vue-text-format'
Vue.use(format)



import token from './utils/token'
Vue.prototype.$token = token

import { storageHandle, sessionHandle } from './utils/storage'
Vue.prototype.$storage = storageHandle
Vue.prototype.$session = sessionHandle

import { warnMsg } from './utils/warnMsg'
Vue.prototype.$warnMsg = warnMsg

import SearchCompany from '@/components/SearchCompany.vue'
Vue.component('SearchCompany', SearchCompany)

import GButton from './components/GButton'
Vue.component('g-button', GButton)
import GlassDrawer from '@/components/GlassDrawer.vue'
Vue.component('GlassDrawer', GlassDrawer)
import NoData from '@/components/NoData.vue'
Vue.component('no-data', NoData)
import ESwitch from '@/components/ESwitch.vue'
Vue.component('e-switch', ESwitch)
// 单选按钮组， 详情卡片切换
import GTabNav from '@/components/GTabNav'
Vue.component('g-tab-nav', GTabNav)

Vue.prototype.$bus = new Vue()


Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD61QgYiXuY7-JV5PrGqdIsXiB8oNGpVk8',
    libraries: 'places',
    useBetaRenderer: false

  }
})
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
